import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStreets: build.query<GetStreetsApiResponse, GetStreetsApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/AddressData/streets/${queryArg.cityName}/${queryArg.neighborhoodName}`,
      }),
    }),
    getNeighborhoods: build.query<
      GetNeighborhoodsApiResponse,
      GetNeighborhoodsApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/AddressData/neighborhoods/${queryArg.cityName}/${queryArg.districtName}`,
      }),
    }),
    getDistricts: build.query<GetDistrictsApiResponse, GetDistrictsApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/AddressData/districts/${queryArg.cityName}`,
      }),
    }),
    getCities: build.query<GetCitiesApiResponse, GetCitiesApiArg>({
      query: () => ({ url: `/authenticationservice/v1/AddressData/cities` }),
    }),
    updateAddress: build.mutation<
      UpdateAddressApiResponse,
      UpdateAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Addresses/${queryArg.addressId}`,
        method: 'PUT',
        body: queryArg.addressUpdateRequest,
      }),
    }),
    getAddress: build.query<GetAddressApiResponse, GetAddressApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Addresses/${queryArg.addressId}`,
      }),
    }),
    deleteAddress: build.mutation<
      DeleteAddressApiResponse,
      DeleteAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Addresses/${queryArg.addressId}`,
        method: 'DELETE',
      }),
    }),
    getAddresses: build.query<GetAddressesApiResponse, GetAddressesApiArg>({
      query: () => ({ url: `/authenticationservice/v1/Addresses/addresses` }),
    }),
    createAddress: build.mutation<
      CreateAddressApiResponse,
      CreateAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Addresses/addresses`,
        method: 'POST',
        body: queryArg.addressCreateRequest,
      }),
    }),
    getAddressesByUserId: build.query<
      GetAddressesByUserIdApiResponse,
      GetAddressesByUserIdApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/Addresses/user` }),
    }),
    checkAppVersionAsync: build.query<
      CheckAppVersionAsyncApiResponse,
      CheckAppVersionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/AppVersions/check`,
        params: {
          currentVersion: queryArg.currentVersion,
          platform: queryArg.platform,
        },
      }),
    }),
    createAppVersionAsync: build.mutation<
      CreateAppVersionAsyncApiResponse,
      CreateAppVersionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/AppVersions`,
        method: 'POST',
        body: queryArg.createAppVersionRequest,
      }),
    }),
    verifyResetPasswordOtp: build.mutation<
      VerifyResetPasswordOtpApiResponse,
      VerifyResetPasswordOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/verify-reset-password-otp`,
        method: 'POST',
        body: queryArg.verifyResetPasswordOtpRequest,
      }),
    }),
    verifyDeviceOtp: build.mutation<
      VerifyDeviceOtpApiResponse,
      VerifyDeviceOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/verify-device-otp`,
        method: 'POST',
        body: queryArg.verifyDeviceOtpRequest,
      }),
    }),
    sendResetPasswordOtp: build.mutation<
      SendResetPasswordOtpApiResponse,
      SendResetPasswordOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/send-reset-password-otp`,
        method: 'POST',
        body: queryArg.sendResetPasswordOtpRequest,
      }),
    }),
    sendDeviceOtp: build.mutation<
      SendDeviceOtpApiResponse,
      SendDeviceOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/send-device-otp`,
        method: 'POST',
        body: queryArg.sendDeviceOtpRequest,
      }),
    }),
    refreshAccessToken: build.mutation<
      RefreshAccessTokenApiResponse,
      RefreshAccessTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/refresh-token`,
        method: 'POST',
        body: queryArg.refreshTokenRequest,
      }),
    }),
    logoutUser: build.mutation<LogoutUserApiResponse, LogoutUserApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/logout`,
        method: 'POST',
        body: queryArg.logoutRequest,
      }),
    }),
    getLoginHistory: build.query<
      GetLoginHistoryApiResponse,
      GetLoginHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/login-history`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    loginUser: build.mutation<LoginUserApiResponse, LoginUserApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/login`,
        method: 'POST',
        body: queryArg.loginRequest,
      }),
    }),
    getLastLoginAlert: build.query<
      GetLastLoginAlertApiResponse,
      GetLastLoginAlertApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/auth/last-login-alert` }),
    }),
    checkResetPasswordOtp: build.mutation<
      CheckResetPasswordOtpApiResponse,
      CheckResetPasswordOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/auth/check-reset-password-otp`,
        method: 'POST',
        body: queryArg.checkResetPasswordOtpRequest,
      }),
    }),
    getAllUserEarningsAsync: build.query<
      GetAllUserEarningsAsyncApiResponse,
      GetAllUserEarningsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/referrals/user-earnings`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getEarningsBreakdownAsync: build.query<
      GetEarningsBreakdownAsyncApiResponse,
      GetEarningsBreakdownAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/referrals/earnings-breakdown/${queryArg.userId}`,
      }),
    }),
    getUserEarningsByUserIdAsync: build.query<
      GetUserEarningsByUserIdAsyncApiResponse,
      GetUserEarningsByUserIdAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/referrals/user-earnings/${queryArg.userId}`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getAllReferralsAsync: build.query<
      GetAllReferralsAsyncApiResponse,
      GetAllReferralsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/referrals`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getReferralByIdAsync: build.query<
      GetReferralByIdAsyncApiResponse,
      GetReferralByIdAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/referrals/${queryArg.id}`,
      }),
    }),
    getReferralStatsAsync: build.query<
      GetReferralStatsAsyncApiResponse,
      GetReferralStatsAsyncApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/Backoffice/referrals/stats`,
      }),
    }),
    generateShareLinks: build.mutation<
      GenerateShareLinksApiResponse,
      GenerateShareLinksApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users/generate-share-links`,
        method: 'POST',
      }),
    }),
    getAllMehirAppUsers: build.query<
      GetAllMehirAppUsersApiResponse,
      GetAllMehirAppUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getMehirAppUserById: build.query<
      GetMehirAppUserByIdApiResponse,
      GetMehirAppUserByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users/${queryArg.id}`,
      }),
    }),
    updateMehirAppUser: build.mutation<
      UpdateMehirAppUserApiResponse,
      UpdateMehirAppUserApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateMehirAppUserRequest,
      }),
    }),
    getMehirAppUserByRealUserId: build.query<
      GetMehirAppUserByRealUserIdApiResponse,
      GetMehirAppUserByRealUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users/by-real-user-id/${queryArg.realUserId}`,
      }),
    }),
    updateMehirAppUserStatus: build.mutation<
      UpdateMehirAppUserStatusApiResponse,
      UpdateMehirAppUserStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/mehir-app-users/${queryArg.id}/status`,
        method: 'PATCH',
        body: queryArg.updateMehirAppUserStatusRequest,
      }),
    }),
    createCommunicationPermissionAsync: build.mutation<
      CreateCommunicationPermissionAsyncApiResponse,
      CreateCommunicationPermissionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions`,
        method: 'POST',
        body: queryArg.createCommunicationPermissionRequest,
      }),
    }),
    getAllCommunicationPermissionsAsync: build.query<
      GetAllCommunicationPermissionsAsyncApiResponse,
      GetAllCommunicationPermissionsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    deleteCommunicationPermissionAsync: build.mutation<
      DeleteCommunicationPermissionAsyncApiResponse,
      DeleteCommunicationPermissionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getCommunicationPermissionByIdAsync: build.query<
      GetCommunicationPermissionByIdAsyncApiResponse,
      GetCommunicationPermissionByIdAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions/${queryArg.id}`,
      }),
    }),
    updateCommunicationPermissionAsync: build.mutation<
      UpdateCommunicationPermissionAsyncApiResponse,
      UpdateCommunicationPermissionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateCommunicationPermissionRequest,
      }),
    }),
    getCommunicationPermissionsByUserIdAsync: build.query<
      GetCommunicationPermissionsByUserIdAsyncApiResponse,
      GetCommunicationPermissionsByUserIdAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions/user/${queryArg.userId}`,
      }),
    }),
    syncCommunicationPermissionsAsync: build.mutation<
      SyncCommunicationPermissionsAsyncApiResponse,
      SyncCommunicationPermissionsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Backoffice/communication-permissions/user/${queryArg.userId}/sync`,
        method: 'POST',
        body: queryArg.syncCommunicationPermissionsRequest,
      }),
    }),
    updateCommunicationPermission: build.mutation<
      UpdateCommunicationPermissionApiResponse,
      UpdateCommunicationPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/CommunicationPermissions/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateCommunicationPermissionRequest1,
      }),
    }),
    syncCommunicationPermissions: build.mutation<
      SyncCommunicationPermissionsApiResponse,
      SyncCommunicationPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/CommunicationPermissions/sync`,
        method: 'POST',
        body: queryArg.syncCommunicationPermissionsRequest1,
      }),
    }),
    getCommunicationPermissions: build.query<
      GetCommunicationPermissionsApiResponse,
      GetCommunicationPermissionsApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/CommunicationPermissions`,
      }),
    }),
    createCommunicationPermission: build.mutation<
      CreateCommunicationPermissionApiResponse,
      CreateCommunicationPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/CommunicationPermissions`,
        method: 'POST',
        body: queryArg.createCommunicationPermissionRequest1,
      }),
    }),
    getCommunicationPermissionsJson: build.query<
      GetCommunicationPermissionsJsonApiResponse,
      GetCommunicationPermissionsJsonApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/CommunicationPermissions/json`,
      }),
    }),
    getDevicesByUserId: build.query<
      GetDevicesByUserIdApiResponse,
      GetDevicesByUserIdApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/Devices/users/devices` }),
    }),
    getAllDevices: build.query<GetAllDevicesApiResponse, GetAllDevicesApiArg>({
      query: () => ({ url: `/authenticationservice/v1/Devices/devices` }),
    }),
    createDevice: build.mutation<CreateDeviceApiResponse, CreateDeviceApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Devices/devices`,
        method: 'POST',
        body: queryArg.deviceCreateRequest,
      }),
    }),
    getDevice: build.query<GetDeviceApiResponse, GetDeviceApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Devices/${queryArg.deviceId}`,
      }),
    }),
    deleteDevice: build.mutation<DeleteDeviceApiResponse, DeleteDeviceApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Devices/${queryArg.deviceId}`,
        method: 'DELETE',
      }),
    }),
    getCustomToken: build.query<
      GetCustomTokenApiResponse,
      GetCustomTokenApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/Firebase/custom-token` }),
    }),
    getPresignedUrl: build.mutation<
      GetPresignedUrlApiResponse,
      GetPresignedUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Media/presigned-url`,
        method: 'POST',
        body: queryArg.presignedUrlRequest,
      }),
    }),
    updateNotificationPermission: build.mutation<
      UpdateNotificationPermissionApiResponse,
      UpdateNotificationPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/NotificationPermissions/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateNotificationPermissionRequest,
      }),
    }),
    syncNotificationPermissions: build.mutation<
      SyncNotificationPermissionsApiResponse,
      SyncNotificationPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/NotificationPermissions/sync`,
        method: 'POST',
        body: queryArg.syncNotificationPermissionsRequest,
      }),
    }),
    getNotificationPermissions: build.query<
      GetNotificationPermissionsApiResponse,
      GetNotificationPermissionsApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/NotificationPermissions`,
      }),
    }),
    createNotificationPermission: build.mutation<
      CreateNotificationPermissionApiResponse,
      CreateNotificationPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/NotificationPermissions`,
        method: 'POST',
        body: queryArg.createNotificationPermissionRequest,
      }),
    }),
    getNotificationPermissionsJson: build.query<
      GetNotificationPermissionsJsonApiResponse,
      GetNotificationPermissionsJsonApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/NotificationPermissions/json`,
      }),
    }),
    sendCredentialNotification: build.mutation<
      SendCredentialNotificationApiResponse,
      SendCredentialNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Notifications/notifications/send-credential`,
        method: 'POST',
        body: queryArg.sendCredentialNotificationRequest,
      }),
    }),
    sendCredentialNotificationWithUserId: build.mutation<
      SendCredentialNotificationWithUserIdApiResponse,
      SendCredentialNotificationWithUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Notifications/notifications/send-credential-with-user-id`,
        method: 'POST',
        body: queryArg.sendCredentialNotificationWithUserIdRequest,
      }),
    }),
    completeProfileInfo: build.mutation<
      CompleteProfileInfoApiResponse,
      CompleteProfileInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/complete-profile`,
        method: 'POST',
        body: queryArg.completeProfileInfoRequest,
      }),
    }),
    createPassword: build.mutation<
      CreatePasswordApiResponse,
      CreatePasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/create-password`,
        method: 'POST',
        body: queryArg.createPasswordRequest,
      }),
    }),
    initiateRegistration: build.mutation<
      InitiateRegistrationApiResponse,
      InitiateRegistrationApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/initiate`,
        method: 'POST',
        body: queryArg.initiateRegistrationRequest,
      }),
    }),
    resendOtp: build.mutation<ResendOtpApiResponse, ResendOtpApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/resend-otp`,
        method: 'POST',
        body: queryArg.resendOtpRequest,
      }),
    }),
    verifyEmailOtp: build.mutation<
      VerifyEmailOtpApiResponse,
      VerifyEmailOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/verify-email`,
        method: 'POST',
        body: queryArg.verifyEmailOtpRequest,
      }),
    }),
    verifyPhoneOtp: build.mutation<
      VerifyPhoneOtpApiResponse,
      VerifyPhoneOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/Registration/verify-phone`,
        method: 'POST',
        body: queryArg.verifyPhoneOtpRequest,
      }),
    }),
    getServiceStatus: build.query<
      GetServiceStatusApiResponse,
      GetServiceStatusApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/service-status` }),
    }),
    getServiceStatusByName: build.query<
      GetServiceStatusByNameApiResponse,
      GetServiceStatusByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/service-status/${queryArg.name}`,
      }),
    }),
    getSupportRequestsEndpoint: build.query<
      GetSupportRequestsEndpointApiResponse,
      GetSupportRequestsEndpointApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/support/requests`,
        params: {
          status: queryArg.status,
          page: queryArg.page,
          perPage: queryArg.perPage,
        },
      }),
    }),
    createSupportRequestEndpoint: build.mutation<
      CreateSupportRequestEndpointApiResponse,
      CreateSupportRequestEndpointApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/support/requests`,
        method: 'POST',
        body: queryArg.createSupportRequestRequest,
      }),
    }),
    getSupportRequestDetailEndpoint: build.query<
      GetSupportRequestDetailEndpointApiResponse,
      GetSupportRequestDetailEndpointApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/support/requests/${queryArg.requestId}`,
      }),
    }),
    addSupportRequestCommentEndpoint: build.mutation<
      AddSupportRequestCommentEndpointApiResponse,
      AddSupportRequestCommentEndpointApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/support/requests/${queryArg.requestId}/comments`,
        method: 'POST',
        body: queryArg.addCommentRequest,
      }),
    }),
    getCurrentUser: build.query<
      GetCurrentUserApiResponse,
      GetCurrentUserApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/users/me` }),
    }),
    getInvitedUsersCount: build.query<
      GetInvitedUsersCountApiResponse,
      GetInvitedUsersCountApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/users/invited/count` }),
    }),
    getInvitedUsers: build.query<
      GetInvitedUsersApiResponse,
      GetInvitedUsersApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/users/invited` }),
    }),
    getInvitedUsersSummary: build.query<
      GetInvitedUsersSummaryApiResponse,
      GetInvitedUsersSummaryApiArg
    >({
      query: () => ({ url: `/authenticationservice/v1/users/invited/summary` }),
    }),
    getKycStatus: build.query<GetKycStatusApiResponse, GetKycStatusApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/${queryArg.userId}/kyc-status`,
      }),
    }),
    getUserProfileByPhone: build.query<
      GetUserProfileByPhoneApiResponse,
      GetUserProfileByPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/by-phone/${queryArg.phoneNumber}`,
      }),
    }),
    sendEmailUpdateOtp: build.mutation<
      SendEmailUpdateOtpApiResponse,
      SendEmailUpdateOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/email/send-otp`,
        method: 'POST',
        body: queryArg.sendEmailUpdateOtpRequest,
      }),
    }),
    sendPhoneUpdateOtp: build.mutation<
      SendPhoneUpdateOtpApiResponse,
      SendPhoneUpdateOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/phone/send-otp`,
        method: 'POST',
        body: queryArg.sendPhoneUpdateOtpRequest,
      }),
    }),
    setPartner: build.mutation<SetPartnerApiResponse, SetPartnerApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/${queryArg.userId}/partner`,
        method: 'PUT',
        body: queryArg.setPartnerRequest,
      }),
    }),
    updateAvatar: build.mutation<UpdateAvatarApiResponse, UpdateAvatarApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/avatar`,
        method: 'PUT',
        body: queryArg.updateAvatarRequest,
      }),
    }),
    updateEmail: build.mutation<UpdateEmailApiResponse, UpdateEmailApiArg>({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/email`,
        method: 'PUT',
        body: queryArg.updateEmailRequest,
      }),
    }),
    updateMaritalStatus: build.mutation<
      UpdateMaritalStatusApiResponse,
      UpdateMaritalStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/marital-status`,
        method: 'PUT',
        body: queryArg.updateMaritalStatusRequest,
      }),
    }),
    updatePhoneNumber: build.mutation<
      UpdatePhoneNumberApiResponse,
      UpdatePhoneNumberApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/phone`,
        method: 'PUT',
        body: queryArg.updatePhoneNumberRequest,
      }),
    }),
    resetPassword: build.mutation<
      ResetPasswordApiResponse,
      ResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/reset-password`,
        method: 'POST',
        body: queryArg.resetPasswordRequest,
      }),
    }),
    inviteUsersByPhone: build.mutation<
      InviteUsersByPhoneApiResponse,
      InviteUsersByPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/invitations`,
        method: 'POST',
        body: queryArg.inviteUsersByPhoneRequest,
      }),
    }),
    getZendeskToken: build.mutation<
      GetZendeskTokenApiResponse,
      GetZendeskTokenApiArg
    >({
      query: () => ({
        url: `/authenticationservice/v1/users/zendesk-token`,
        method: 'POST',
      }),
    }),
    deleteAccount: build.mutation<
      DeleteAccountApiResponse,
      DeleteAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/delete-account`,
        method: 'DELETE',
        params: {
          reason: queryArg.reason,
        },
      }),
    }),
    confirmKyc: build.mutation<ConfirmKycApiResponse, ConfirmKycApiArg>({
      query: () => ({
        url: `/authenticationservice/v1/users/confirm-kyc`,
        method: 'POST',
      }),
    }),
    checkPhoneNumbers: build.mutation<
      CheckPhoneNumbersApiResponse,
      CheckPhoneNumbersApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/check-phone-numbers`,
        method: 'POST',
        body: queryArg.checkPhoneNumbersRequest,
      }),
    }),
    checkPhoneNumber: build.query<
      CheckPhoneNumberApiResponse,
      CheckPhoneNumberApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/check-phone-number/${queryArg.phoneNumber}`,
      }),
    }),
    checkPassword: build.mutation<
      CheckPasswordApiResponse,
      CheckPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/authenticationservice/v1/users/check-password`,
        method: 'POST',
        body: queryArg.checkPasswordRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as authApi };
export type GetStreetsApiResponse = /** status 200 OK */ StreetViewModel[];
export type GetStreetsApiArg = {
  cityName: string;
  neighborhoodName: string;
};
export type GetNeighborhoodsApiResponse =
  /** status 200 OK */ NeighborhoodViewModel[];
export type GetNeighborhoodsApiArg = {
  cityName: string;
  districtName: string;
};
export type GetDistrictsApiResponse = /** status 200 OK */ DistrictViewModel[];
export type GetDistrictsApiArg = {
  cityName: string;
};
export type GetCitiesApiResponse = /** status 200 OK */ CityViewModel[];
export type GetCitiesApiArg = void;
export type UpdateAddressApiResponse = /** status 204 No Content */ string;
export type UpdateAddressApiArg = {
  addressId: string;
  addressUpdateRequest: AddressUpdateRequest;
};
export type GetAddressApiResponse = /** status 200 OK */ AddressViewModel;
export type GetAddressApiArg = {
  addressId: string;
};
export type DeleteAddressApiResponse = /** status 204 No Content */ string;
export type DeleteAddressApiArg = {
  addressId: string;
};
export type GetAddressesApiResponse = /** status 200 OK */ AddressViewModel[];
export type GetAddressesApiArg = void;
export type CreateAddressApiResponse = /** status 200 OK */ string;
export type CreateAddressApiArg = {
  addressCreateRequest: AddressCreateRequest;
};
export type GetAddressesByUserIdApiResponse =
  /** status 200 OK */ AddressViewModel[];
export type GetAddressesByUserIdApiArg = void;
export type CheckAppVersionAsyncApiResponse =
  /** status 200 OK */ AppVersionCheckViewModel;
export type CheckAppVersionAsyncApiArg = {
  currentVersion: string;
  platform: string;
};
export type CreateAppVersionAsyncApiResponse = unknown;
export type CreateAppVersionAsyncApiArg = {
  createAppVersionRequest: CreateAppVersionRequest;
};
export type VerifyResetPasswordOtpApiResponse =
  /** status 200 OK */ VerifyResetPasswordOtpCommandResponse;
export type VerifyResetPasswordOtpApiArg = {
  verifyResetPasswordOtpRequest: VerifyResetPasswordOtpRequest;
};
export type VerifyDeviceOtpApiResponse =
  /** status 200 OK */ VerifyDeviceOtpCommandResponse;
export type VerifyDeviceOtpApiArg = {
  verifyDeviceOtpRequest: VerifyDeviceOtpRequest;
};
export type SendResetPasswordOtpApiResponse =
  /** status 200 OK */ SendResetPasswordOtpCommandResponse;
export type SendResetPasswordOtpApiArg = {
  sendResetPasswordOtpRequest: SendResetPasswordOtpRequest;
};
export type SendDeviceOtpApiResponse =
  /** status 200 OK */ SendDeviceOtpCommandResponse;
export type SendDeviceOtpApiArg = {
  sendDeviceOtpRequest: SendDeviceOtpRequest;
};
export type RefreshAccessTokenApiResponse =
  /** status 200 OK */ RefreshTokenCommandResponse;
export type RefreshAccessTokenApiArg = {
  refreshTokenRequest: RefreshTokenRequest;
};
export type LogoutUserApiResponse = unknown;
export type LogoutUserApiArg = {
  logoutRequest: LogoutRequest;
};
export type GetLoginHistoryApiResponse =
  /** status 200 OK */ LoginHistoryViewModel[];
export type GetLoginHistoryApiArg = {
  page: number;
  pageSize: number;
};
export type LoginUserApiResponse = /** status 200 OK */ LoginCommandResponse;
export type LoginUserApiArg = {
  loginRequest: LoginRequest;
};
export type GetLastLoginAlertApiResponse =
  /** status 200 OK */ LoginAlertViewModel;
export type GetLastLoginAlertApiArg = void;
export type CheckResetPasswordOtpApiResponse =
  /** status 200 OK */ CheckResetPasswordOtpCommandResponse;
export type CheckResetPasswordOtpApiArg = {
  checkResetPasswordOtpRequest: CheckResetPasswordOtpRequest;
};
export type GetAllUserEarningsAsyncApiResponse =
  /** status 200 OK */ UserEarningsDtoPaginationResponseRead;
export type GetAllUserEarningsAsyncApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetEarningsBreakdownAsyncApiResponse =
  /** status 200 OK */ EarningsBreakdownViewModel;
export type GetEarningsBreakdownAsyncApiArg = {
  userId: string;
};
export type GetUserEarningsByUserIdAsyncApiResponse =
  /** status 200 OK */ UserEarningsDtoPaginationResponseRead;
export type GetUserEarningsByUserIdAsyncApiArg = {
  userId: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetAllReferralsAsyncApiResponse =
  /** status 200 OK */ InvitedUserDtoPaginationResponseRead;
export type GetAllReferralsAsyncApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetReferralByIdAsyncApiResponse =
  /** status 200 OK */ InvitedUserDto;
export type GetReferralByIdAsyncApiArg = {
  id: string;
};
export type GetReferralStatsAsyncApiResponse =
  /** status 200 OK */ ReferralStatsViewModel;
export type GetReferralStatsAsyncApiArg = void;
export type GenerateShareLinksApiResponse =
  /** status 200 OK */ GenerateShareLinksResponse;
export type GenerateShareLinksApiArg = void;
export type GetAllMehirAppUsersApiResponse =
  /** status 200 OK */ UserReadModelPaginationResponseRead;
export type GetAllMehirAppUsersApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetMehirAppUserByIdApiResponse =
  /** status 200 OK */ MehirAppUserDetailDto;
export type GetMehirAppUserByIdApiArg = {
  id: string;
};
export type UpdateMehirAppUserApiResponse = unknown;
export type UpdateMehirAppUserApiArg = {
  id: string;
  updateMehirAppUserRequest: UpdateMehirAppUserRequest;
};
export type GetMehirAppUserByRealUserIdApiResponse =
  /** status 200 OK */ MehirAppUserDetailDto;
export type GetMehirAppUserByRealUserIdApiArg = {
  realUserId: string;
};
export type UpdateMehirAppUserStatusApiResponse = unknown;
export type UpdateMehirAppUserStatusApiArg = {
  id: string;
  updateMehirAppUserStatusRequest: UpdateMehirAppUserStatusRequest;
};
export type CreateCommunicationPermissionAsyncApiResponse =
  /** status 201 Created */ string;
export type CreateCommunicationPermissionAsyncApiArg = {
  createCommunicationPermissionRequest: CreateCommunicationPermissionRequest;
};
export type GetAllCommunicationPermissionsAsyncApiResponse =
  /** status 200 OK */ UserCommunicationPermissionsDtoPaginationResponseRead;
export type GetAllCommunicationPermissionsAsyncApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type DeleteCommunicationPermissionAsyncApiResponse = unknown;
export type DeleteCommunicationPermissionAsyncApiArg = {
  id: string;
};
export type GetCommunicationPermissionByIdAsyncApiResponse =
  /** status 200 OK */ CommunicationPermissionDto;
export type GetCommunicationPermissionByIdAsyncApiArg = {
  id: string;
};
export type UpdateCommunicationPermissionAsyncApiResponse = unknown;
export type UpdateCommunicationPermissionAsyncApiArg = {
  id: string;
  updateCommunicationPermissionRequest: UpdateCommunicationPermissionRequest;
};
export type GetCommunicationPermissionsByUserIdAsyncApiResponse =
  /** status 200 OK */ UserCommunicationPermissionsDto;
export type GetCommunicationPermissionsByUserIdAsyncApiArg = {
  userId: string;
};
export type SyncCommunicationPermissionsAsyncApiResponse = unknown;
export type SyncCommunicationPermissionsAsyncApiArg = {
  userId: string;
  syncCommunicationPermissionsRequest: SyncCommunicationPermissionsRequest;
};
export type UpdateCommunicationPermissionApiResponse =
  /** status 200 OK */ string;
export type UpdateCommunicationPermissionApiArg = {
  id: string;
  updateCommunicationPermissionRequest1: UpdateCommunicationPermissionRequest1;
};
export type SyncCommunicationPermissionsApiResponse = unknown;
export type SyncCommunicationPermissionsApiArg = {
  syncCommunicationPermissionsRequest1: SyncCommunicationPermissionsRequest1;
};
export type GetCommunicationPermissionsApiResponse =
  /** status 200 OK */ CommunicationPermissionReadModel[];
export type GetCommunicationPermissionsApiArg = void;
export type CreateCommunicationPermissionApiResponse =
  /** status 201 Created */ string;
export type CreateCommunicationPermissionApiArg = {
  createCommunicationPermissionRequest1: CreateCommunicationPermissionRequest1;
};
export type GetCommunicationPermissionsJsonApiResponse = /** status 200 OK */ {
  email?: boolean;
  sms?: boolean;
  phone?: boolean;
  push?: boolean;
};
export type GetCommunicationPermissionsJsonApiArg = void;
export type GetDevicesByUserIdApiResponse =
  /** status 200 OK */ DeviceViewModel[];
export type GetDevicesByUserIdApiArg = void;
export type GetAllDevicesApiResponse = /** status 200 OK */ DeviceViewModel[];
export type GetAllDevicesApiArg = void;
export type CreateDeviceApiResponse = /** status 200 OK */ string;
export type CreateDeviceApiArg = {
  deviceCreateRequest: DeviceCreateRequest;
};
export type GetDeviceApiResponse = /** status 200 OK */ DeviceViewModel;
export type GetDeviceApiArg = {
  deviceId: string;
};
export type DeleteDeviceApiResponse = unknown;
export type DeleteDeviceApiArg = {
  deviceId: string;
};
export type GetCustomTokenApiResponse =
  /** status 200 OK */ FirebaseCustomTokenResponse;
export type GetCustomTokenApiArg = void;
export type GetPresignedUrlApiResponse =
  /** status 200 OK */ PresignedUrlResponse;
export type GetPresignedUrlApiArg = {
  presignedUrlRequest: PresignedUrlRequest;
};
export type UpdateNotificationPermissionApiResponse =
  /** status 200 OK */ string;
export type UpdateNotificationPermissionApiArg = {
  id: string;
  updateNotificationPermissionRequest: UpdateNotificationPermissionRequest;
};
export type SyncNotificationPermissionsApiResponse = unknown;
export type SyncNotificationPermissionsApiArg = {
  syncNotificationPermissionsRequest: SyncNotificationPermissionsRequest;
};
export type GetNotificationPermissionsApiResponse =
  /** status 200 OK */ NotificationPermissionReadModel[];
export type GetNotificationPermissionsApiArg = void;
export type CreateNotificationPermissionApiResponse =
  /** status 201 Created */ string;
export type CreateNotificationPermissionApiArg = {
  createNotificationPermissionRequest: CreateNotificationPermissionRequest;
};
export type GetNotificationPermissionsJsonApiResponse = /** status 200 OK */ {
  news_and_offers?: boolean;
  campaign_update?: boolean;
  app?: boolean;
};
export type GetNotificationPermissionsJsonApiArg = void;
export type SendCredentialNotificationApiResponse =
  /** status 200 OK */ boolean;
export type SendCredentialNotificationApiArg = {
  sendCredentialNotificationRequest: SendCredentialNotificationRequest;
};
export type SendCredentialNotificationWithUserIdApiResponse =
  /** status 200 OK */ boolean;
export type SendCredentialNotificationWithUserIdApiArg = {
  sendCredentialNotificationWithUserIdRequest: SendCredentialNotificationWithUserIdRequest;
};
export type CompleteProfileInfoApiResponse =
  /** status 200 OK */ CompleteProfileInfoCommandResponse;
export type CompleteProfileInfoApiArg = {
  completeProfileInfoRequest: CompleteProfileInfoRequest;
};
export type CreatePasswordApiResponse =
  /** status 200 OK */ CreatePasswordCommandResponse;
export type CreatePasswordApiArg = {
  createPasswordRequest: CreatePasswordRequest;
};
export type InitiateRegistrationApiResponse =
  /** status 200 OK */ InitiateRegistrationCommandResponse;
export type InitiateRegistrationApiArg = {
  initiateRegistrationRequest: InitiateRegistrationRequest;
};
export type ResendOtpApiResponse =
  /** status 200 OK */ ResendOtpCommandResponse;
export type ResendOtpApiArg = {
  resendOtpRequest: ResendOtpRequest;
};
export type VerifyEmailOtpApiResponse =
  /** status 200 OK */ VerifyEmailOtpCommandResponse;
export type VerifyEmailOtpApiArg = {
  verifyEmailOtpRequest: VerifyEmailOtpRequest;
};
export type VerifyPhoneOtpApiResponse =
  /** status 200 OK */ VerifyPhoneOtpCommandResponse;
export type VerifyPhoneOtpApiArg = {
  verifyPhoneOtpRequest: VerifyPhoneOtpRequest;
};
export type GetServiceStatusApiResponse =
  /** status 200 OK */ GetServiceStatusQueryResponse;
export type GetServiceStatusApiArg = void;
export type GetServiceStatusByNameApiResponse =
  /** status 200 OK */ GetServiceStatusByNameResponse;
export type GetServiceStatusByNameApiArg = {
  name: string;
};
export type GetSupportRequestsEndpointApiResponse =
  /** status 200 OK */ GetSupportRequestsResponse;
export type GetSupportRequestsEndpointApiArg = {
  status?: string;
  page: number;
  perPage: number;
};
export type CreateSupportRequestEndpointApiResponse =
  /** status 201 Created */ CreateSupportRequestResponse;
export type CreateSupportRequestEndpointApiArg = {
  createSupportRequestRequest: CreateSupportRequestRequest;
};
export type GetSupportRequestDetailEndpointApiResponse =
  /** status 200 OK */ GetSupportRequestDetailResponse;
export type GetSupportRequestDetailEndpointApiArg = {
  requestId: number;
};
export type AddSupportRequestCommentEndpointApiResponse =
  /** status 200 OK */ AddCommentResponse;
export type AddSupportRequestCommentEndpointApiArg = {
  requestId: number;
  addCommentRequest: AddCommentRequest;
};
export type GetCurrentUserApiResponse = /** status 200 OK */ UserReadModel;
export type GetCurrentUserApiArg = void;
export type GetInvitedUsersCountApiResponse = /** status 200 OK */ number;
export type GetInvitedUsersCountApiArg = void;
export type GetInvitedUsersApiResponse = /** status 200 OK */ InvitedUserDto[];
export type GetInvitedUsersApiArg = void;
export type GetInvitedUsersSummaryApiResponse =
  /** status 200 OK */ InvitedUsersSummaryDto;
export type GetInvitedUsersSummaryApiArg = void;
export type GetKycStatusApiResponse = /** status 200 OK */ boolean;
export type GetKycStatusApiArg = {
  userId: string;
};
export type GetUserProfileByPhoneApiResponse =
  /** status 200 OK */ UserProfileDto;
export type GetUserProfileByPhoneApiArg = {
  phoneNumber: string;
};
export type SendEmailUpdateOtpApiResponse =
  /** status 200 OK */ SendEmailUpdateOtpCommandResponse;
export type SendEmailUpdateOtpApiArg = {
  sendEmailUpdateOtpRequest: SendEmailUpdateOtpRequest;
};
export type SendPhoneUpdateOtpApiResponse =
  /** status 200 OK */ SendPhoneUpdateOtpCommandResponse;
export type SendPhoneUpdateOtpApiArg = {
  sendPhoneUpdateOtpRequest: SendPhoneUpdateOtpRequest;
};
export type SetPartnerApiResponse = unknown;
export type SetPartnerApiArg = {
  userId: string;
  setPartnerRequest: SetPartnerRequest;
};
export type UpdateAvatarApiResponse =
  /** status 200 OK */ UpdateAvatarCommandResponse;
export type UpdateAvatarApiArg = {
  updateAvatarRequest: UpdateAvatarRequest;
};
export type UpdateEmailApiResponse =
  /** status 200 OK */ UpdateEmailCommandResponse;
export type UpdateEmailApiArg = {
  updateEmailRequest: UpdateEmailRequest;
};
export type UpdateMaritalStatusApiResponse =
  /** status 200 OK */ UpdateMaritalStatusCommandResponse;
export type UpdateMaritalStatusApiArg = {
  updateMaritalStatusRequest: UpdateMaritalStatusRequest;
};
export type UpdatePhoneNumberApiResponse =
  /** status 200 OK */ UpdatePhoneNumberCommandResponse;
export type UpdatePhoneNumberApiArg = {
  updatePhoneNumberRequest: UpdatePhoneNumberRequest;
};
export type ResetPasswordApiResponse = unknown;
export type ResetPasswordApiArg = {
  resetPasswordRequest: ResetPasswordRequest;
};
export type InviteUsersByPhoneApiResponse =
  /** status 200 OK */ InviteUsersByPhoneResponse;
export type InviteUsersByPhoneApiArg = {
  inviteUsersByPhoneRequest: InviteUsersByPhoneRequest;
};
export type GetZendeskTokenApiResponse =
  /** status 200 OK */ GetZendeskTokenResponse;
export type GetZendeskTokenApiArg = void;
export type DeleteAccountApiResponse =
  /** status 200 OK */ DeleteAccountCommandResponse;
export type DeleteAccountApiArg = {
  reason?: string;
};
export type ConfirmKycApiResponse =
  /** status 200 OK */ ConfirmKycCommandResponse;
export type ConfirmKycApiArg = void;
export type CheckPhoneNumbersApiResponse =
  /** status 200 OK */ PhoneNumberRegistrationStatus[];
export type CheckPhoneNumbersApiArg = {
  checkPhoneNumbersRequest: CheckPhoneNumbersRequest;
};
export type CheckPhoneNumberApiResponse =
  /** status 200 OK */ CheckPhoneNumberQueryResponse;
export type CheckPhoneNumberApiArg = {
  phoneNumber: string;
};
export type CheckPasswordApiResponse = /** status 200 OK */ boolean;
export type CheckPasswordApiArg = {
  checkPasswordRequest: CheckPasswordRequest;
};
export type StreetViewModel = {
  name?: string | null;
  cityName?: string | null;
  districtName?: string | null;
  neighborhoodName?: string | null;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type NeighborhoodViewModel = {
  neighborhoodName?: string | null;
  cityName?: string | null;
  districtName?: string | null;
};
export type DistrictViewModel = {
  districtName?: string | null;
  cityName?: string | null;
};
export type CityViewModel = {
  ilId?: number;
  ilAdi?: string | null;
};
export type AddressUpdateRequest = {
  title?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
};
export type AddressViewModel = {
  id?: string;
  title?: string | null;
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
};
export type AddressCreateRequest = {
  title?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
};
export type AppVersionCheckViewModel = {
  needUpdate?: boolean;
  forceUpdate?: boolean;
  latestVersion?: string | null;
  changelog?: string | null;
};
export type CreateAppVersionRequest = {
  versionNumber?: string | null;
  platform?: string | null;
  isForceUpdate?: boolean;
  changelog?: string | null;
  minimumVersion?: string | null;
};
export type VerifyResetPasswordOtpCommandResponse = {
  message?: string | null;
};
export type VerifyResetPasswordOtpRequest = {
  phoneNumber?: string | null;
  otpCode?: string | null;
  newPassword?: string | null;
};
export type VerifyDeviceOtpCommandResponse = {
  accessToken?: string | null;
  refreshToken?: string | null;
  message?: string | null;
};
export type VerifyDeviceOtpRequest = {
  phoneNumber?: string | null;
  password?: string | null;
  otpCode?: string | null;
  deviceName?: string | null;
};
export type SendResetPasswordOtpCommandResponse = {
  message?: string | null;
};
export type SendResetPasswordOtpRequest = {
  phoneNumber?: string | null;
};
export type SendDeviceOtpCommandResponse = {
  message?: string | null;
};
export type SendDeviceOtpRequest = {
  phoneNumber?: string | null;
};
export type RefreshTokenCommandResponse = {
  accessToken?: string | null;
  refreshToken?: string | null;
};
export type RefreshTokenRequest = {
  refreshToken?: string | null;
};
export type LogoutRequest = {
  refreshToken?: string | null;
};
export type LoginHistoryViewModel = {
  id?: string;
  time?: string;
  type?: string | null;
  ipAddress?: string | null;
  deviceId?: string | null;
  deviceName?: string | null;
  failureReason?: string | null;
};
export type LoginCommandResponse = {
  accessToken?: string | null;
  refreshToken?: string | null;
  requiresDeviceVerification?: boolean;
  message?: string | null;
};
export type LoginRequest = {
  phoneNumber?: string | null;
  password?: string | null;
};
export type LoginAlertViewModel = {
  failedLoginTime?: string;
  ipAddress?: string | null;
  deviceId?: string | null;
  failureReason?: string | null;
  failedAttemptCount?: number;
  lastSuccessfulLoginTime?: string;
  lastSuccessfulLoginIpAddress?: string | null;
  lastSuccessfulLoginDeviceId?: string | null;
};
export type CheckResetPasswordOtpCommandResponse = {
  isValid?: boolean;
  message?: string | null;
  userId?: string | null;
};
export type CheckResetPasswordOtpRequest = {
  phoneNumber?: string | null;
  otpCode?: string | null;
};
export type GiftType = 'gold' | 'silver' | 'cash';
export type UserDetailsDto = {
  userId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};
export type UserEarningsDto = {
  id?: string;
  userId?: string | null;
  giftType?: GiftType;
  count?: number;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
  user?: UserDetailsDto;
};
export type UserEarningsDtoPaginationResponse = {
  items?: UserEarningsDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type UserEarningsDtoPaginationResponseRead = {
  items?: UserEarningsDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type UserDetailsDto1 = {
  userId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};
export type EarningsBreakdownViewModel = {
  userId?: string | null;
  totalGold?: number;
  totalSilver?: number;
  totalCash?: number;
  totalCount?: number;
  user?: UserDetailsDto1;
};
export type InviterDetailsDto = {
  userId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
};
export type InviteeDetailsDto = {
  userId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
};
export type InvitedUserDto = {
  invitedUserId?: string;
  inviteCode?: string | null;
  invitedAt?: string;
  registeredAt?: string | null;
  status?: string | null;
  invitedPhoneNumber?: string | null;
  inviter?: InviterDetailsDto;
  invitee?: InviteeDetailsDto;
};
export type InvitedUserDtoPaginationResponse = {
  items?: InvitedUserDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type InvitedUserDtoPaginationResponseRead = {
  items?: InvitedUserDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ReferralStatsViewModel = {
  totalReferrals?: number;
  totalGoldEarned?: number;
  totalSilverEarned?: number;
  totalCashEarned?: number;
};
export type GenerateShareLinksResponse = {
  totalUsers?: number;
  successCount?: number;
  failureCount?: number;
  failedUserIds?: string[] | null;
};
export type Gender = 'male' | 'female';
export type MarriageStatus = 'married' | 'singled';
export type UserReadModel = {
  id?: string;
  realUserId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Gender;
  maritalStatus?: MarriageStatus;
  inviteCode?: string | null;
  mehirId?: string | null;
  isKycConfirm?: boolean;
  isPhoneVerified?: boolean;
  isEmailVerified?: boolean;
  isActive?: boolean;
  avatarUrl?: string | null;
  shareLink?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
};
export type UserReadModelPaginationResponse = {
  items?: UserReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type UserReadModelPaginationResponseRead = {
  items?: UserReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type InviterInfoDto = {
  invitationId?: string;
  realUserId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
  inviteCode?: string | null;
  invitedAt?: string;
  registeredAt?: string | null;
};
export type InvitedUserInfoDto = {
  invitationId?: string;
  status?: string | null;
  invitedPhoneNumber?: string | null;
  inviteCode?: string | null;
  invitedAt?: string;
  registeredAt?: string | null;
  realUserId?: string | null;
  mehirId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
};
export type DeviceViewModel = {
  id?: string;
  userId?: string | null;
  tokenId?: string | null;
  deviceName?: string | null;
  ip?: string | null;
  location?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};
export type MehirAppUserDetailDto = {
  user?: UserReadModel;
  invitedBy?: InviterInfoDto;
  invitedUsers?: InvitedUserInfoDto[] | null;
  devices?: DeviceViewModel[] | null;
};
export type UpdateMehirAppUserRequest = {
  email?: string | null;
  isActive?: boolean | null;
};
export type UpdateMehirAppUserStatusRequest = {
  isActive?: boolean;
};
export type CommunicationPermissionType = 'email' | 'sms' | 'phone' | 'push';
export type CreateCommunicationPermissionRequest = {
  userId?: string | null;
  type?: CommunicationPermissionType;
  isAllowed?: boolean;
};
export type UserDetailsDto2 = {
  userId?: string | null;
  mehirId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};
export type CommunicationPermissionTypeDto = {
  id?: string;
  type?: CommunicationPermissionType;
  isAllowed?: boolean;
  createdAt?: string;
};
export type UserCommunicationPermissionsDto = {
  user?: UserDetailsDto2;
  permissions?: CommunicationPermissionTypeDto[] | null;
};
export type UserCommunicationPermissionsDtoPaginationResponse = {
  items?: UserCommunicationPermissionsDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type UserCommunicationPermissionsDtoPaginationResponseRead = {
  items?: UserCommunicationPermissionsDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type CommunicationPermissionDto = {
  id?: string;
  userId?: string | null;
  type?: CommunicationPermissionType;
  isAllowed?: boolean;
  createdAt?: string;
  user?: UserDetailsDto2;
};
export type UpdateCommunicationPermissionRequest = {
  isAllowed?: boolean;
};
export type SyncCommunicationPermissionsRequest = {
  permissions?: {
    email?: boolean;
    sms?: boolean;
    phone?: boolean;
    push?: boolean;
  } | null;
};
export type UpdateCommunicationPermissionRequest1 = {
  isAllowed?: boolean;
};
export type SyncCommunicationPermissionsRequest1 = {
  permissions?: {
    email?: boolean;
    sms?: boolean;
    phone?: boolean;
    push?: boolean;
  } | null;
};
export type CommunicationPermissionReadModel = {
  id?: string;
  userId?: string | null;
  type?: CommunicationPermissionType;
  isAllowed?: boolean;
  createdAt?: string;
  isDeleted?: boolean;
};
export type CreateCommunicationPermissionRequest1 = {
  type?: CommunicationPermissionType;
  isAllowed?: boolean;
};
export type DeviceCreateRequest = {
  deviceToken?: string | null;
  deviceName?: string | null;
};
export type FirebaseCustomTokenResponse = {
  /** Firebase custom token for client-side authentication */
  customToken?: string | null;
};
export type PresignedUrlResponse = {
  uploadUrl?: string | null;
  fileUrl?: string | null;
};
export type PresignedUrlRequest = {
  bucket?: string | null;
  fileName?: string | null;
  contentType?: string | null;
};
export type UpdateNotificationPermissionRequest = {
  isAllowed?: boolean;
};
export type SyncNotificationPermissionsRequest = {
  permissions?: {
    news_and_offers?: boolean;
    campaign_update?: boolean;
    app?: boolean;
  } | null;
};
export type NotificationPermissionType =
  | 'news_and_offers'
  | 'campaign_update'
  | 'app';
export type NotificationPermissionReadModel = {
  id?: string;
  userId?: string | null;
  type?: NotificationPermissionType;
  isAllowed?: boolean;
  createdAt?: string;
  isDeleted?: boolean;
};
export type CreateNotificationPermissionRequest = {
  type?: NotificationPermissionType;
  isAllowed?: boolean;
};
export type SendCredentialNotificationRequest = {
  deviceToken?: string | null;
};
export type SendCredentialNotificationWithUserIdRequest = {
  deviceToken?: string | null;
  userId?: string | null;
};
export type CompleteProfileInfoCommandResponse = {
  sessionToken?: string | null;
  currentStep?: string | null;
  message?: string | null;
};
export type CompleteProfileInfoRequest = {
  sessionToken?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Gender;
  maritalStatus?: MarriageStatus;
};
export type CreatePasswordCommandResponse = {
  userId?: string | null;
  message?: string | null;
  gender?: Gender;
};
export type CreatePasswordRequest = {
  sessionToken?: string | null;
  password?: string | null;
  deviceName?: string | null;
};
export type InitiateRegistrationCommandResponse = {
  sessionToken?: string | null;
  currentStep?: string | null;
};
export type InitiateRegistrationRequest = {
  phoneNumber?: string | null;
  email?: string | null;
  inviteCode?: string | null;
};
export type ResendOtpCommandResponse = {
  sessionToken?: string | null;
  currentStep?: string | null;
  message?: string | null;
};
export type OtpType = 1 | 2;
export type ResendOtpRequest = {
  sessionToken?: string | null;
  otpType?: OtpType;
};
export type VerifyEmailOtpCommandResponse = {
  sessionToken?: string | null;
  currentStep?: string | null;
  message?: string | null;
};
export type VerifyEmailOtpRequest = {
  sessionToken?: string | null;
  otpCode?: string | null;
};
export type VerifyPhoneOtpCommandResponse = {
  sessionToken?: string | null;
  currentStep?: string | null;
  message?: string | null;
};
export type VerifyPhoneOtpRequest = {
  sessionToken?: string | null;
  otpCode?: string | null;
};
export type GetServiceStatusQueryResponse = {
  status?: boolean;
};
export type GetServiceStatusByNameResponse = {
  name?: string | null;
  status?: boolean;
};
export type SupportAttachment = {
  name?: string | null;
  url?: string | null;
};
export type SupportRequestItem = {
  id?: number;
  subject?: string | null;
  description?: string | null;
  status?: string | null;
  requestNo?: string | null;
  attachments?: SupportAttachment[] | null;
  createdAt?: string;
  updatedAt?: string | null;
};
export type GetSupportRequestsResponse = {
  items?: SupportRequestItem[] | null;
  totalCount?: number;
  page?: number;
  perPage?: number;
};
export type CreateSupportRequestResponse = {
  id?: number;
  subject?: string | null;
  status?: string | null;
  createdAt?: string;
};
export type CreateSupportRequestRequest = {
  subject?: string | null;
  description?: string | null;
  attachmentUrls?: string[] | null;
};
export type SupportAttachment1 = {
  name?: string | null;
  url?: string | null;
};
export type SupportComment = {
  id?: number;
  body?: string | null;
  authorName?: string | null;
  isAgent?: boolean;
  createdAt?: string;
  attachments?: SupportAttachment1[] | null;
};
export type GetSupportRequestDetailResponse = {
  id?: number;
  subject?: string | null;
  description?: string | null;
  status?: string | null;
  requestNo?: string | null;
  attachments?: SupportAttachment1[] | null;
  comments?: SupportComment[] | null;
  createdAt?: string;
  updatedAt?: string | null;
};
export type AddCommentResponse = {
  id?: number;
  body?: string | null;
  createdAt?: string;
};
export type AddCommentRequest = {
  body?: string | null;
  attachmentUrls?: string[] | null;
};
export type InvitedUserSummaryItem = {
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
};
export type InvitedUsersSummaryDto = {
  totalInvited?: number;
  totalRegistered?: number;
  latestRegistered?: InvitedUserSummaryItem[] | null;
};
export type UserProfileDto = {
  gender?: Gender;
  marriageStatus?: MarriageStatus;
  realUserId?: string | null;
  mehirId?: string | null;
};
export type SendEmailUpdateOtpCommandResponse = {
  message?: string | null;
};
export type SendEmailUpdateOtpRequest = {
  newEmail?: string | null;
};
export type SendPhoneUpdateOtpCommandResponse = {
  message?: string | null;
};
export type SendPhoneUpdateOtpRequest = {
  newPhoneNumber?: string | null;
};
export type SetPartnerRequest = {
  partnerId?: string | null;
};
export type UpdateAvatarCommandResponse = {
  message?: string | null;
};
export type UpdateAvatarRequest = {
  avatarUrl?: string | null;
};
export type UpdateEmailCommandResponse = {
  message?: string | null;
};
export type UpdateEmailRequest = {
  newEmail?: string | null;
  otpCode?: string | null;
};
export type UpdateMaritalStatusCommandResponse = {
  message?: string | null;
};
export type UpdateMaritalStatusRequest = {
  maritalStatus?: MarriageStatus;
};
export type UpdatePhoneNumberCommandResponse = {
  message?: string | null;
};
export type UpdatePhoneNumberRequest = {
  newPhoneNumber?: string | null;
  otpCode?: string | null;
};
export type ResetPasswordRequest = {
  currentPassword?: string | null;
  newPassword?: string | null;
};
export type InviteUsersByPhoneResponse = {
  created?: number;
  skipped?: number;
  invalid?: string[] | null;
};
export type InviteUsersByPhoneRequest = {
  phoneNumbers?: string[] | null;
};
export type GetZendeskTokenResponse = {
  token?: string | null;
};
export type DeleteAccountCommandResponse = {
  message?: string | null;
};
export type ConfirmKycCommandResponse = {
  message?: string | null;
};
export type PhoneNumberRegistrationStatus = {
  phoneNumber?: string | null;
  isRegistered?: boolean;
};
export type CheckPhoneNumbersRequest = {
  phoneNumbers?: string[] | null;
};
export type CheckPhoneNumberQueryResponse = {
  isRegistered?: boolean;
  fullName?: string | null;
  avatarUrl?: string | null;
};
export type CheckPasswordRequest = {
  password?: string | null;
};
export const {
  useGetStreetsQuery,
  useLazyGetStreetsQuery,
  useGetNeighborhoodsQuery,
  useLazyGetNeighborhoodsQuery,
  useGetDistrictsQuery,
  useLazyGetDistrictsQuery,
  useGetCitiesQuery,
  useLazyGetCitiesQuery,
  useUpdateAddressMutation,
  useGetAddressQuery,
  useLazyGetAddressQuery,
  useDeleteAddressMutation,
  useGetAddressesQuery,
  useLazyGetAddressesQuery,
  useCreateAddressMutation,
  useGetAddressesByUserIdQuery,
  useLazyGetAddressesByUserIdQuery,
  useCheckAppVersionAsyncQuery,
  useLazyCheckAppVersionAsyncQuery,
  useCreateAppVersionAsyncMutation,
  useVerifyResetPasswordOtpMutation,
  useVerifyDeviceOtpMutation,
  useSendResetPasswordOtpMutation,
  useSendDeviceOtpMutation,
  useRefreshAccessTokenMutation,
  useLogoutUserMutation,
  useGetLoginHistoryQuery,
  useLazyGetLoginHistoryQuery,
  useLoginUserMutation,
  useGetLastLoginAlertQuery,
  useLazyGetLastLoginAlertQuery,
  useCheckResetPasswordOtpMutation,
  useGetAllUserEarningsAsyncQuery,
  useLazyGetAllUserEarningsAsyncQuery,
  useGetEarningsBreakdownAsyncQuery,
  useLazyGetEarningsBreakdownAsyncQuery,
  useGetUserEarningsByUserIdAsyncQuery,
  useLazyGetUserEarningsByUserIdAsyncQuery,
  useGetAllReferralsAsyncQuery,
  useLazyGetAllReferralsAsyncQuery,
  useGetReferralByIdAsyncQuery,
  useLazyGetReferralByIdAsyncQuery,
  useGetReferralStatsAsyncQuery,
  useLazyGetReferralStatsAsyncQuery,
  useGenerateShareLinksMutation,
  useGetAllMehirAppUsersQuery,
  useLazyGetAllMehirAppUsersQuery,
  useGetMehirAppUserByIdQuery,
  useLazyGetMehirAppUserByIdQuery,
  useUpdateMehirAppUserMutation,
  useGetMehirAppUserByRealUserIdQuery,
  useLazyGetMehirAppUserByRealUserIdQuery,
  useUpdateMehirAppUserStatusMutation,
  useCreateCommunicationPermissionAsyncMutation,
  useGetAllCommunicationPermissionsAsyncQuery,
  useLazyGetAllCommunicationPermissionsAsyncQuery,
  useDeleteCommunicationPermissionAsyncMutation,
  useGetCommunicationPermissionByIdAsyncQuery,
  useLazyGetCommunicationPermissionByIdAsyncQuery,
  useUpdateCommunicationPermissionAsyncMutation,
  useGetCommunicationPermissionsByUserIdAsyncQuery,
  useLazyGetCommunicationPermissionsByUserIdAsyncQuery,
  useSyncCommunicationPermissionsAsyncMutation,
  useUpdateCommunicationPermissionMutation,
  useSyncCommunicationPermissionsMutation,
  useGetCommunicationPermissionsQuery,
  useLazyGetCommunicationPermissionsQuery,
  useCreateCommunicationPermissionMutation,
  useGetCommunicationPermissionsJsonQuery,
  useLazyGetCommunicationPermissionsJsonQuery,
  useGetDevicesByUserIdQuery,
  useLazyGetDevicesByUserIdQuery,
  useGetAllDevicesQuery,
  useLazyGetAllDevicesQuery,
  useCreateDeviceMutation,
  useGetDeviceQuery,
  useLazyGetDeviceQuery,
  useDeleteDeviceMutation,
  useGetCustomTokenQuery,
  useLazyGetCustomTokenQuery,
  useGetPresignedUrlMutation,
  useUpdateNotificationPermissionMutation,
  useSyncNotificationPermissionsMutation,
  useGetNotificationPermissionsQuery,
  useLazyGetNotificationPermissionsQuery,
  useCreateNotificationPermissionMutation,
  useGetNotificationPermissionsJsonQuery,
  useLazyGetNotificationPermissionsJsonQuery,
  useSendCredentialNotificationMutation,
  useSendCredentialNotificationWithUserIdMutation,
  useCompleteProfileInfoMutation,
  useCreatePasswordMutation,
  useInitiateRegistrationMutation,
  useResendOtpMutation,
  useVerifyEmailOtpMutation,
  useVerifyPhoneOtpMutation,
  useGetServiceStatusQuery,
  useLazyGetServiceStatusQuery,
  useGetServiceStatusByNameQuery,
  useLazyGetServiceStatusByNameQuery,
  useGetSupportRequestsEndpointQuery,
  useLazyGetSupportRequestsEndpointQuery,
  useCreateSupportRequestEndpointMutation,
  useGetSupportRequestDetailEndpointQuery,
  useLazyGetSupportRequestDetailEndpointQuery,
  useAddSupportRequestCommentEndpointMutation,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useGetInvitedUsersCountQuery,
  useLazyGetInvitedUsersCountQuery,
  useGetInvitedUsersQuery,
  useLazyGetInvitedUsersQuery,
  useGetInvitedUsersSummaryQuery,
  useLazyGetInvitedUsersSummaryQuery,
  useGetKycStatusQuery,
  useLazyGetKycStatusQuery,
  useGetUserProfileByPhoneQuery,
  useLazyGetUserProfileByPhoneQuery,
  useSendEmailUpdateOtpMutation,
  useSendPhoneUpdateOtpMutation,
  useSetPartnerMutation,
  useUpdateAvatarMutation,
  useUpdateEmailMutation,
  useUpdateMaritalStatusMutation,
  useUpdatePhoneNumberMutation,
  useResetPasswordMutation,
  useInviteUsersByPhoneMutation,
  useGetZendeskTokenMutation,
  useDeleteAccountMutation,
  useConfirmKycMutation,
  useCheckPhoneNumbersMutation,
  useCheckPhoneNumberQuery,
  useLazyCheckPhoneNumberQuery,
  useCheckPasswordMutation,
} = injectedRtkApi;
